// Configuration management
const config = {
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    stripeKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
    apiUrl: import.meta.env.VITE_API_URL,
    siteUrl: import.meta.env.VITE_SITE_URL,
    basePrice: parseFloat(import.meta.env.VITE_BASE_PRICE || '0.10'),
    priceMultiplier: parseFloat(import.meta.env.VITE_PRICE_MULTIPLIER || '1.5'),
    decayRate: parseFloat(import.meta.env.VITE_DECAY_RATE || '0.0001')
};

export async function initConfig() {
    try {
        // In production, we use the environment variables directly
        if (import.meta.env.PROD) {
            return config;
        }

        // In development, we can fetch from the config worker
        const configWorkerUrl = import.meta.env.VITE_CONFIG_WORKER_URL;
        if (configWorkerUrl) {
            const response = await fetch(configWorkerUrl);
            if (!response.ok) {
                throw new Error('Failed to fetch config from worker');
            }
            const workerConfig = await response.json();
            return { ...config, ...workerConfig };
        }

        return config;
    } catch (error) {
        console.error('Error initializing config:', error);
        return config; // Fallback to environment variables
    }
}

export default config; 